var _circle, _circle2, _circle3, _rect, _path, _path2, _path3, _path4, _path5, _g, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountClosed = function SvgAccountClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Account_Closed_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Account_Closed_svg__a)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 63,
    cy: 7,
    r: 25,
    stroke: "#000",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -8,
    y: 50,
    width: 55,
    height: 60,
    rx: 2,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.752 44.722c8.17 0 14.792-6.653 14.792-14.86C56.544 21.653 49.922 15 41.753 15c-8.17 0-14.792 6.654-14.792 14.861 0 8.208 6.622 14.861 14.791 14.861Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.752 42.722c8.17 0 14.792-6.653 14.792-14.86C54.544 19.653 47.922 13 39.753 13c-8.17 0-14.792 6.654-14.792 14.861 0 8.208 6.622 14.861 14.791 14.861Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.362 51.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 71 150.917V78.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.362 47.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 67 146.917V74.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#EDE3D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Account_Closed_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 47,
    width: 54,
    height: 109
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.362 47.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 67 146.917V74.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Account_Closed_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 46.49a18.28 18.28 0 0 0 6.473 6.246A17.264 17.264 0 0 0 40 55c2.977 0 5.908-.778 8.527-2.264A18.28 18.28 0 0 0 55 46.49a21.352 21.352 0 0 0-7.901-5.194 20.536 20.536 0 0 0-9.255-1.19c-4.865.476-9.413 2.736-12.844 6.384Z",
    fill: "#000"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.171,
    y: 5.757,
    width: 10,
    height: 92.509,
    rx: 5,
    transform: "rotate(45 71.171 5.757)",
    fill: "#000",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.309,
    y: 1.62,
    width: 10,
    height: 98.556,
    rx: 5,
    transform: "rotate(45 71.31 1.62)",
    fill: "#DAC6AB"
  })));
};
export default SvgAccountClosed;